function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StyledPositionsCareersComponent } from "./positions-careers-component.scss";
import { filterPositions, getDeptIDFromPosition, getLocationIDFromPosition, reorderPositions, sortPositionsByName } from "./utils";
import { useEffect, useMemo, useState, useRef } from "react";
import { withGenericConfig } from "contexts/generic-config-context";
import { CAREER_KIND_SPECIFIC_POSITION_CLICKED, CAREER_PAGE_CLICK } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { getRandomInt } from "services/utils-service";
import PositionComponent from "segments/desktop/careers/layouts/positions-careers/position/position-component";
import PaginationComponent from "./pagination/pagination-component";
import { useFilters } from "contexts/careers-context";
import { POSITIONS_ID } from "segments/desktop/careers/layouts/consts";
import EmptyStateComponent from "./empty-state/empty-state-component";
import { getDeptID } from "components/pages/careers/careers-service";
import * as Sentry from "@sentry/nextjs";
import { loadTeammeWidget } from "components/pages/careers/teamme-widget-service";
import { getLocationID } from "components/pages/careers/careers-service";
// how many positions to show in full page:
const TABLE_RESULTS_PAGE_SIZE = 10;
const CAREERS_ROOT_URL = "/careers/";
const HEADER_OFFSET = 170;
const pageLoadUniqueId = getRandomInt(100000000);
const PositionsCareersComponent = ({ positionsType, dynamicProps, emptyState, emptyStateAdvancedConfig })=>{
    const { positions, teammeApiKey } = dynamicProps || {};
    const { search, department, location, updatePositionsPerLocation } = useFilters();
    const [positionsData, setPositionsData] = useState(positions || []);
    const [currentPageNum, setCurrentPageNum] = useState(1);
    const isFirstRender = useRef(true);
    const positionsRef = useRef(null);
    const filteredPositions = useMemo(()=>filterPositions(positions, search, department, location), [
        positions,
        search,
        department,
        location
    ]);
    const filteredLocationsCount = useMemo(()=>location ? 1 : [
            ...new Set(filteredPositions === null || filteredPositions === void 0 ? void 0 : filteredPositions.map((position)=>getLocationIDFromPosition(position)))
        ].length, [
        location,
        filteredPositions
    ]);
    const filteredTeamsCount = useMemo(()=>department ? 1 : [
            ...new Set(filteredPositions.map((pos)=>getDeptIDFromPosition(pos)))
        ].length, [
        department,
        filteredPositions
    ]);
    const numOfPages = !filteredPositions ? 1 : Math.ceil(filteredPositions.length / TABLE_RESULTS_PAGE_SIZE);
    const getPositionsPage = (pageIdx)=>{
        if (!filteredPositions) return [];
        return filteredPositions.slice((pageIdx - 1) * TABLE_RESULTS_PAGE_SIZE, pageIdx * TABLE_RESULTS_PAGE_SIZE);
    };
    const getPositionLink = (position)=>{
        return `${CAREERS_ROOT_URL}${position.uid}`;
    };
    const onPositionClick = (event, position)=>{
        trackEvent(CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_SPECIFIC_POSITION_CLICKED,
            info1: position === null || position === void 0 ? void 0 : position.name,
            info2: location,
            info3: department,
            placement: pageLoadUniqueId
        });
    };
    useEffect(()=>{
        let displayedPositions = sortPositionsByName(filteredPositions);
        const locations = [
            "aviv",
            "aviv",
            "york",
            "sf",
            "london",
            "miami"
        ];
        displayedPositions = reorderPositions(displayedPositions, locations);
        setPositionsData(displayedPositions);
    }, [
        filteredPositions
    ]);
    useEffect(()=>{
        setCurrentPageNum(1);
    }, [
        search,
        department,
        location
    ]);
    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const scrollToPositions = ()=>{
            const positionsElement = positionsRef.current;
            if (!positionsElement) {
                Sentry.captureMessage("Could not find positions element for scrolling");
                return;
            }
            const rect = positionsElement.getBoundingClientRect();
            const scrollTarget = rect.top + window.pageYOffset - HEADER_OFFSET;
            window.scrollTo({
                top: scrollTarget,
                left: 0,
                behavior: "smooth"
            });
        };
        scrollToPositions();
    }, [
        currentPageNum
    ]);
    useEffect(()=>{
        const filterByDepartment = department ? positions === null || positions === void 0 ? void 0 : positions.filter((position)=>getDeptID(position.department) === department) : positions;
        updatePositionsPerLocation(filterByDepartment);
    }, [
        department,
        positions,
        updatePositionsPerLocation
    ]);
    useEffect(()=>{
        // Only show teamme widget if there are German positions (Munich) in the list
        const hasGermanPositions = positions === null || positions === void 0 ? void 0 : positions.some((position)=>{
            var _position_location;
            const locationID = getLocationID(position === null || position === void 0 ? void 0 : (_position_location = position.location) === null || _position_location === void 0 ? void 0 : _position_location.name);
            return locationID === "munich";
        });
        if (hasGermanPositions && teammeApiKey) {
            loadTeammeWidget(teammeApiKey);
        }
    }, [
        teammeApiKey,
        positions
    ]);
    const positionsOnPage = positionsData && getPositionsPage(currentPageNum);
    return /*#__PURE__*/ _jsxs(StyledPositionsCareersComponent, {
        ref: positionsRef,
        id: POSITIONS_ID,
        className: "positions-careers-component",
        children: [
            !!(positionsData === null || positionsData === void 0 ? void 0 : positionsData.length) && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "overview",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "number",
                                children: positionsData.length
                            }),
                            " ",
                            positionsData.length === 1 ? "job" : "jobs",
                            " in ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "number",
                                children: filteredLocationsCount
                            }),
                            " ",
                            positionsData.length === 1 ? "location" : "locations",
                            " in ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "number",
                                children: filteredTeamsCount
                            }),
                            " ",
                            positionsData.length === 1 ? "team" : "teams"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "positions-container",
                        children: positionsData && positionsOnPage.map((position, index)=>/*#__PURE__*/ _jsxs("div", {
                                className: "position-container",
                                children: [
                                    /*#__PURE__*/ _jsx(PositionComponent, {
                                        position: position,
                                        link: getPositionLink(position),
                                        onClick: (event)=>onPositionClick(event, position)
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "divider"
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ _jsx(PaginationComponent, {
                        currentPageNum: currentPageNum,
                        numberOfPositions: filteredPositions === null || filteredPositions === void 0 ? void 0 : filteredPositions.length,
                        setPageNumber: setCurrentPageNum,
                        numOfPages: numOfPages
                    })
                ]
            }),
            !(positionsData === null || positionsData === void 0 ? void 0 : positionsData.length) && /*#__PURE__*/ _jsx(EmptyStateComponent, _object_spread_props(_object_spread({}, emptyState), {
                emptyStateAdvancedConfig: emptyStateAdvancedConfig
            }))
        ]
    });
};
export default withGenericConfig(PositionsCareersComponent);
